/**
 * POST loyalty profiling consent — resolves shop tenant on platform chrome.
 */
import type { ApiClient } from '../../shared/api/ApiClient.js';
import { hasCustomerApiTenant } from '../../shared/tenant/customerApiTenant.js';
import { customerLogger } from '../../shared/logging/customerLogger.js';
import type { CustomerMembershipItemDTO } from '../account/accountTypes.js';
import { pickLoyaltyApiTenantFromMemberships } from '../account/presenters/pickLoyaltyApiTenantFromMemberships.js';

export async function syncLoyaltyProfilingConsent(input: {
  readonly api: ApiClient;
  readonly browseTenantCode: string;
  readonly customerId: number;
  readonly granted: boolean;
  readonly memberships?: readonly CustomerMembershipItemDTO[] | null;
}): Promise<void> {
  let effectiveTenant = input.browseTenantCode.trim();
  if (!hasCustomerApiTenant(effectiveTenant)) {
    const picked = pickLoyaltyApiTenantFromMemberships(input.memberships);
    if (picked === null) {
      customerLogger.warn('profiling consent sync skipped: no ACTIVE shop tenant', {
        browseTenantCode: input.browseTenantCode,
        customerId: input.customerId,
        granted: input.granted,
      });
      return;
    }
    effectiveTenant = picked;
  }

  await input.api.request('/loyalty/consent/profiling', {
    method: 'POST',
    body: {
      customerId: input.customerId,
      granted: input.granted,
      policyVersion: 'loyalty-profiling-v1',
    },
    tenantCode: effectiveTenant,
  });
}
